define(function (require) {
    "use strict";

    var BaseModel = require("models/BaseModel");
    var LocaleResolver = require('i18n/localeResolver');
    var LE = require("app");

    var FILTER_ENUM = {
        ID: "id"
    };

    var PermissionsGridModel = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        PermissionsGridModel = BaseModel.extend({
            defaults: {
                filters:{
                    "id": []
                },
                comparators:{
                    "id":"id"
                }
            },
            name: "PermissionsGridModel",

            pluck: function (_model) {
                return true;
            },

            setFilterValue: function(filterName, filterValue){
                if(!_.isUndefined(this.get("filters." + filterName))){
                    this.set("filters." + filterName, filterValue);
                }
            },

            getFilterValue: function(filterName){
                return this.get("filters." + filterName);
            },

            predicate: function (model) {
                var modelIsInSelection = true;

                var translatedPackageKey = "LEUserManagement.profile.permission."+model.id;
                var isPackageTranslated = LE.translator.hasTranslationKey(LocaleResolver.getDefaultLocale(), translatedPackageKey);

                modelIsInSelection = modelIsInSelection && isPackageTranslated;

                return modelIsInSelection;
            }
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    PermissionsGridModel.FILTER_ENUM = FILTER_ENUM;

    return PermissionsGridModel;
});

